import { getRailsInsuranceDefaultSelected } from "../../RailsAbConfig";

export const TATKAL = {
  code: 'TQ',
  id: 'TQ',
  text: 'Tatkal',
  value: 'Tatkal'
};

export const TRAVEL_INSURANCE = {
  NONE: 0,
  OPTED: 1,
  NOT_OPTED: 2,
  NOT_SELECTED: 3
};

export const defaultTravelInsurance = () => {
  return getRailsInsuranceDefaultSelected();
}

export const SHOW_MYRA_TYPES = ['M0', 'M1', 'M2'];

export const myraBotLink =
  'https://myra.makemytrip.com/chat-expert?lob=RAILS&project=ris_chatbot&page=TRAVELLERS';

export const botStyles = {
  bottom: '65px',
};

export const travelplexBotStyles = {
  bottom: '100px',
  right: '2%',
  fontFamily: 'Lato-Regular',
};

export const PASSWORD_RESET_CONSTANTS = {

  MOBILE_LABEL: 'Password will be sent on registered no. with IRCTC',

  EMAIL_LABEL: 'Password will be sent on registered email with IRCTC',

  MOBILE_OPTION: 'On Mobile Number',

  EMAIL_OPTION: 'On Email Id',

};
 
